module.exports = __webpack_public_path__ + "static/media/rs.3431050d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/languages/rs.svg
// module id = 1866
// module chunks = 0